export default __webpack_public_path__ + "static/media/partners.9ff96d00.svg";